import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'


const EXPECTED_ERRORS = [400, 404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type DeleteQuotationPayload = {
  quotationId: number
}


export class DeleteQuotation extends QuotationRequest<void, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId }: DeleteQuotationPayload) {
    super()

    this.path = `quotation/${quotationId}/`
    this.init = {
      method: 'DELETE',
    }
  }
}
